import React from 'react'
import withStyles from 'constructicon/with-styles'
import styles from './styles'
import { getAvatar } from '../../../lib/avatar'

import Image from 'constructicon/image'
import Section from '../../ui/Section'

const ProfilePicture = ({
  defaultImage = {},
  fundraisingPage,
  spacing,
  styles
}) => (
  <Section spacing={spacing}>
    <Image
      alt={fundraisingPage.name}
      src={getAvatar(fundraisingPage.image, defaultImage.url)}
      styles={styles.image}
    />
  </Section>
)

export default withStyles(styles)(ProfilePicture)
